import { render, staticRenderFns } from "./ParametersInfo.vue?vue&type=template&id=0b9ab1ee&scoped=true&"
import script from "./ParametersInfo.vue?vue&type=script&lang=js&"
export * from "./ParametersInfo.vue?vue&type=script&lang=js&"
import style0 from "./ParametersInfo.vue?vue&type=style&index=0&id=0b9ab1ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ab1ee",
  null
  
)

export default component.exports